import { render } from "./ClassificationGame.vue?vue&type=template&id=a8624a5a&scoped=true"
import script from "./ClassificationGame.vue?vue&type=script&lang=js"
export * from "./ClassificationGame.vue?vue&type=script&lang=js"

import "./ClassificationGame.vue?vue&type=style&index=0&id=a8624a5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8624a5a"]])

export default __exports__